// This import loads the firebase namespace along with all its type information.
import ProfileMediaPreferences from './profile-media-preferences-model'

export async function load_profileMediaPreferencess(): Promise<
  ProfileMediaPreferences[]
> {
  throw 'Not implemented'
}

export async function delete_profileMediaPreferences(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_profileMediaPreferences(): Promise<ProfileMediaPreferences> {
  throw 'Not implemented'
}
